<template>
  <form @submit.prevent="submit" novalidate>
    <input
        type="text"
        v-model="customernr"
        placeholder="Kundennummer, wenn vorhanden"
        :class="{'error':errors.includes('customernr')}"
        @blur="validateField('customernr',validationRules['customernr'])"
    >
    <p v-if="this.$parent.$data.form_customernr_text">{{ this.$parent.$data.form_customernr_text }}</p>

    <div class="select-wrapper">
      <select
          v-model="salutation"
          :class="{'error':errors.includes('salutation')}"
          @blur="validateField('salutation', validationRules['salutation'])"
          required
      >
        <option value="" disabled>Anrede *</option>
        <option value="Herr">Herr</option>
        <option value="Frau">Frau</option>
      </select>
    </div>
    <input
        type="text"
        v-model="company"
        placeholder="Firma"
        :class="{'error':errors.includes('company')}"
        @blur="validateField('company', validationRules['company'])"
    >
    <input
        type="text"
        v-model="firstname"
        placeholder="Vorname *"
        :class="{'error':errors.includes('firstname')}"
        @blur="validateField('firstname',validationRules['firstname'])"
    >
    <input
        type="text"
        v-model="lastname"
        placeholder="Nachname *"
        :class="{'error':errors.includes('lastname')}"
        @blur="validateField('lastname',validationRules['lastname'])"
    >
    <input
        type="text"
        v-model="email"
        placeholder="E-Mail *"
        :class="{'error':errors.includes('email')}"
        @blur="validateField('email',validationRules['email'])"
    >
    <input
        type="text"
        v-model="phone"
        placeholder="Telefon *"
        :class="{'error':errors.includes('phone')}"
        @blur="validateField('phone',validationRules['phone'])"
    >
    <input
        type="text"
        v-model="street"
        placeholder="Strasse *"
        :class="{'error':errors.includes('street')}"
        @blur="validateField('street',validationRules['street'])"
    >
    <input
        type="text"
        v-model="zip"
        placeholder="PLZ *"
        :class="{'error':errors.includes('zip')}"
        @blur="validateField('zip',validationRules['zip'])"
    >
    <input
        type="text"
        v-model="place"
        placeholder="Ort *"
        :class="{'error':errors.includes('place')}"
        @blur="validateField('place',validationRules['place'])"
    >
    <div class="select-wrapper">
      <select
          v-model="partner"
          :class="{'error':errors.includes('partner')}"
          @blur="validateField('partner', validationRules['partner'])"
          required
      >
        <option value="">Auswahl Partner, wenn bekannt</option>
        <option v-for="partner in this.$parent.$data.partners" :key="partner.id"
                :value="`${partner.name} / ${partner.place}`">{{ `${partner.name} / ${partner.place}` }}
        </option>
      </select>
    </div>
    <textarea
        v-model="note"
        placeholder="Bemerkungen"
        :class="{'error':errors.includes('note')}"
        @blur="validateField('note',validationRules['note'])"
    ></textarea>
    <div>
      <input type="checkbox" v-model="agb" id="agb"><label
        for="agb"><span></span>{{ this.$parent.$data.form_checkbox_label }}</label>
      <div v-html="this.$parent.$data.form_checkbox_text" class="checkbox-text"></div>
    </div>
    <button type="submit" class="button" :class="{'disabled':!formIsValid(false)}"><span
        v-html="this.$parent.$data.button_form"></span></button>
  </form>
</template>

<script>
export default {
  name: "ConfiguratorForm",
  data() {
    return {
      salutation: '',
      company: '',
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      street: '',
      zip: '',
      place: '',
      customernr: '',
      partner: '',
      note: '',
      agb: false,
      validationRules: {
        salutation: 'required',
        company: '',
        firstname: 'required',
        lastname: 'required',
        email: 'required,email',
        phone: 'required',
        street: 'required',
        zip: 'required',
        place: 'required',
        customernr: '',
        partner: '',
        note: '',
        agb: 'required',
      },
      errors: []
    }
  },
  methods: {
    submit() {
      if (!this.formIsValid()) {
        return
      }
      this.$root.$emit('formSubmitted', {
        salutation: this.salutation,
        company: this.company,
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        phone: this.phone,
        street: this.street,
        zip: this.zip,
        place: this.place,
        customernr: this.customernr,
        partner: this.partner,
        note: this.note,
      });
    },
    formIsValid(markErrors = true) {
      for (const [key, value] of Object.entries(this.validationRules)) {
        if (!this.validateField(key, value, markErrors)) {
          return false;
        }
      }
      return true;
    },
    validateField(name, type, markErrors = true) {
      if (markErrors) {
        this.errors = this.errors.filter(entry => entry !== name);
      }

      if (type.includes('required') && !this[name]) {
        if (markErrors) {
          this.errors.push(name);
        }
        return false;
      }

      if (type.includes('email') && !this.validateEmail(this[name])) {
        if (markErrors) {
          this.errors.push(name);
        }
        return false;
      }

      return true;
    },
    validateEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
}
</script>
